import {ApiService} from "./api.service";

export class CampaignService extends ApiService {
  constructor(organizationId) {
    super();
    this.organizationId = organizationId;
    // this.endpoint = "/campaigns";
    this.endpoint = `/organizations/${organizationId}/campaigns`;
    this.per = 10;
  }

  uploadBannerImage(id, file) {
    const formData = new FormData();
    formData.append('campaign[banner_image]', file);
    return this.upload(`${this.endpoint}/${id}/`, formData);
  }

  removeBannerImage(id) {
    const url = `${this.endpoint}/${id}/remove_banner_image`;
    return this.post(url);
  }

  donations(id, params) {
    const url = `${this.endpoint}/${id}/donations`;
    return super.get(url, params).then((res) => {
      return res.json;
    });
  }

  gifts(campaignId, timeInterval = "weekly") {
    try {
      let url = `${this.endpoint}/${campaignId}/gifts`;
      let params = new URLSearchParams();

      params.set("time_interval", timeInterval);
      return this.get(url, params)
        .then(response => response?.json);
    } catch {
      return {"error": "error loading donation form"};
    }
  }

  giftPayments(campaignId, timeInterval = "weekly") {
    try {
      let url = `${this.endpoint}/${campaignId}/gift_payments`;
      let params = new URLSearchParams();
      params.set("time_interval", timeInterval);

      return this.get(url, params)
        .then(response => response?.json);
    } catch {
      return {"error": "error loading donation form"};
    }
  }

  topDonors(campaignId, time_interval = "weekly", count = 5) {
    try {
      let url = `${this.endpoint}/${campaignId}/top_donors`;
      let params = new URLSearchParams();
      params.set('count', count.toString());
      params.set('time_interval', time_interval);

      return this.get(url, params)
        .then(response => response?.json);

    } catch {
      return {"error": "error loading donation form"};
    }
  }

  giftTypes(campaignId, time_interval = "weekly") {
    try {
      const url = `${this.endpoint}/${campaignId}/gift_types`;
      const params = new URLSearchParams();
      params.set('time_interval', time_interval);

      return this.get(url, params)
        .then(response => response?.json);

    } catch (error) {
      console.error('Error fetching gift types:', error);
      throw error;
    }
  }

  giftFrequencies(campaignId, time_interval = "weekly") {
    try {
      const url = `${this.endpoint}/${campaignId}/gift_frequencies`;
      const params = new URLSearchParams();
      params.set('time_interval', time_interval);

      return this.get(url, params)
        .then(response => response?.json);

    } catch (error) {
      console.error('Error fetching gift frequencies:', error);
      throw error;
    }
  }


}
